import { useAppSelector } from 'store/hooks';
import React from 'react';
import { Box, InputAdornment } from '@mui/material';
import { Row } from 'ui/Flex';
import Search from '@mui/icons-material/Search';
import { DebouncedGridFilterInput } from 'lib/grid/DebouncedGridFilterInput';
import { NotificationSourceFilter } from 'components/notification/filters/NotificationSourceFilter';
export interface NotificationsFilter {
    search?: string;
    source?: 'API' | 'SCHEDULED_TASK' | 'RULE';
    sourceId?: string;
}
export type NotificationsFilterChange = (field: keyof NotificationsFilter, value: string) => void;

interface NotificationsFiltersProps {
    filter: NotificationsFilter;
    onChange: NotificationsFilterChange;
}

export const NotificationsFilters: React.FC<NotificationsFiltersProps> = ({ filter, onChange }) => {
    const { settings } = useAppSelector(state => state.settings);
    const handleSearchChange = React.useCallback(
        (value?: string) => {
            onChange('search', value);
        },
        [onChange]
    );
    const handleSourceChange = React.useCallback(
        (value?: string) => {
            onChange('source', value);
            onChange('sourceId', undefined); // Reset sourceId when source changes
        },
        [onChange]
    );
    const handleSourceIdChange = React.useCallback(
        (value?: string) => {
            onChange('sourceId', value);
        },
        [onChange]
    );

    return (
        <Row flex={1} wrap="wrap" valign="center">
            <Box marginTop={0.5} marginRight={1}>
                <DebouncedGridFilterInput
                    value={filter.search}
                    onChange={handleSearchChange}
                    name="search"
                    placeholder="Search by title, message or tag"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        )
                    }}
                />
            </Box>
            {(!!settings?.scheduledNotificationsEnabled || !!settings?.triggeredNotificationsEnabled) && (
                <>
                    <Box marginRight={1}>
                        <NotificationSourceFilter value={filter.source} onChange={handleSourceChange} />
                    </Box>
                    {filter.source && filter.source !== 'API' && (
                        <Box marginRight={1}>
                            <DebouncedGridFilterInput
                                value={filter.sourceId}
                                onChange={handleSourceIdChange}
                                name="sourceId"
                                placeholder={`Search by ${
                                    filter.source === 'SCHEDULED_TASK' ? 'Scheduled Task' : 'Rule'
                                } ID`}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Box>
                    )}
                </>
            )}
        </Row>
    );
};
